import { useEffect, useState } from 'react';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { Link, useSearch } from '@tanstack/react-router';
import { Plus, RefreshCw, Settings } from 'lucide-react';
import { KioskDevicesTable } from '../components/KioskDevicesTable';
import { mockKioskDevices, mockKioskSettings } from '../data/mock-kiosk-data';
import { KioskDevice } from '../types';

export function KioskDevicesListPage() {
  const { settingsId } = useSearch({ from: '/_authenticated/kiosk/devices/' });
  const [devices, setDevices] = useState<KioskDevice[]>(mockKioskDevices);
  const [settingsName, setSettingsName] = useState<string | null>(null);
  
  // Filter devices by settingsId if provided
  useEffect(() => {
    if (settingsId) {
      const filteredDevices = mockKioskDevices.filter(device => device.settingsId === settingsId);
      setDevices(filteredDevices);
      
      // Find settings name for the header
      const settings = mockKioskSettings.find(s => s.id === settingsId);
      setSettingsName(settings?.name || null);
    } else {
      setDevices(mockKioskDevices);
      setSettingsName(null);
    }
  }, [settingsId]);
  
  return (
    <>
      <PageHeader
        title={settingsName ? `Devices - ${settingsName}` : "Kiosk Devices"}
        description={settingsName 
          ? `Manage devices using the "${settingsName}" settings profile.` 
          : "Manage kiosk devices and their settings."}
        actions={
          <>
            {settingsId && (
              <Button asChild variant="outline" size="sm">
                <Link to="/kiosk/settings/$id" params={{ id: settingsId }}>
                  <Settings className="mr-2 h-4 w-4" />
                  View Settings
                </Link>
              </Button>
            )}
            <Button variant="outline" size="sm">
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh
            </Button>
            <Button asChild size="sm">
              <Link to="/kiosk/devices/add" search={{ settingsId: undefined }}>
                <Plus className="mr-2 h-4 w-4" />
                Register Device
              </Link>
            </Button>
          </>
        }
      />
      
      <div className="space-y-4">
        <KioskDevicesTable data={devices} />
      </div>
    </>
  );
}

export default KioskDevicesListPage;
